export const ComboBoxStyles = {
  root: {
    paddingLeft: 12,
  },
  header: {
    padding: '0 16px',
    height: 32,
    lineHeight: 32,
  },
  optionsContainer: {
    selectors: {
      '.ms-ComboBox-option': {
        padding: '5px 16px',
        minHeight: 32,
      },
      '.ms-ComboBox-optionText': {
        margin: 1,
      },
      '.ms-Button-flexContainer > span': {
        display: 'block',
      },
    },
  },
};
